import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import styles from './styles';

const MobileSelectNameAutoComplete = (props) => {
  const { id, field, value: dataValue, data = [], updateData, maxLength } = props;
  const classes = styles();

  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');

  useEffect(() => {
    setValue(dataValue);
    setInputValue(dataValue);
  }, [id]);

  const commitValue = (newValue) => {
    updateData(id, field, newValue ?? '');
    setValue(newValue);
    setInputValue(newValue ?? '');
  };

  return (
    <FormControl
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <Autocomplete
        freeSolo
        options={[...new Set(data)].sort()}
        value={value}
        inputValue={inputValue}
        onChange={(event, newValue) => {
          commitValue(newValue);
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            commitValue(inputValue);
          }
        }}
        sx={{
          '& .MuiAutocomplete-input': {
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            width: '100%'
          },
          '& .MuiAutocomplete-inputRoot ': {
            paddingRight: '0px !important',
            paddingTop: '4px'
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label={inputValue ? '' : 'Select or Enter'}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true
            }}
            inputProps={{
              ...params.inputProps,
              maxLength
            }}
          />
        )}
      />
    </FormControl>
  );
};

MobileSelectNameAutoComplete.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  field: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.string),
  updateData: PropTypes.func.isRequired,
  closeCellAfterSelect: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string
};

export default MobileSelectNameAutoComplete;
